import React from "react";
import PropTypes from "prop-types";
import { MuiThemeProvider, createTheme } from "@material-ui/core";
import defaultTheme from "../styles/theme";
import Horizontal from "./Horizontal";
import Vertical from "./Vertical";
import DefaultLayout from "./DefaultLayout";
import { getColour } from "../actions/utils";

export default class Navigation extends React.Component {
  constructor() {
    super();
    this.state = { matches: window.matchMedia("(min-width: 960px)").matches };
  }

  componentDidMount = () => {
    // read from embedded screen if possible
    const fieldErrors = document.getElementById("fieldErrors")?.value || "";
    const actionErrors = document.getElementById("actionErrors")?.value || "";
    const gitVersion = document.getElementById("gitVersion")?.value || "";
    const javascriptCacheDate =
      document.getElementById("javascriptCacheDate")?.value || "";

    const loginEndpoint = document.getElementById("loginEndpoint")?.value || "";
    const imageUrl = document.getElementById("imageUrl")?.value || "";
    const imageFilename =
      document.getElementById("imageFilename")?.value || "transparent.gif";
    const showLogo = imageFilename !== "transparent.gif";

    const footerText = document.getElementById("footerText")?.value || "";

    const brandingOverRideText =
      document.getElementById("brandingOverRide")?.value || "{}";
    const brandingOverRide = JSON.parse(
      brandingOverRideText
        .replace(
          /&amp;|&lt;|&gt;|&#39;|&quot;|/g,
          (tag) =>
            ({
              "&amp;": "&",
              "&lt;": "<",
              "&gt;": ">",
              "&#39;": "'",
              "&quot;": '"',
            })[tag] || tag,
        )
        .replaceAll("\n", "{newline}"),
    );
    console.debug(brandingOverRide);
    if (
      brandingOverRide.primaryColour &&
      brandingOverRide.primaryColour !== "none"
    ) {
      defaultTheme.palette.primary.main = getColour(
        brandingOverRide.primaryColour,
      );
    }
    if (
      brandingOverRide.secondaryColour &&
      brandingOverRide.secondaryColour !== "none"
    ) {
      defaultTheme.palette.secondary.main = getColour(
        brandingOverRide.secondaryColour,
      );
    }
    if (
      brandingOverRide.primaryBackgroundColour &&
      brandingOverRide.primaryBackgroundColour !== "none"
    ) {
      defaultTheme.overrides.MuiPaper.root.backgroundColor = getColour(
        brandingOverRide.primaryBackgroundColour,
      );
    }
    if (
      brandingOverRide.secondaryBackgroundColour &&
      brandingOverRide.secondaryBackgroundColour !== "none"
    ) {
      defaultTheme.overrides.MuiCssBaseline["@global"].body.backgroundColor =
        getColour(brandingOverRide.secondaryBackgroundColour);
    }
    if (
      brandingOverRide.navigationTextColour &&
      brandingOverRide.navigationTextColour !== "none"
    ) {
      defaultTheme.palette.text.primary = getColour(
        brandingOverRide.navigationTextColour,
      );
    }
    if (
      brandingOverRide.navigationBackgroundColour &&
      brandingOverRide.navigationBackgroundColour !== "none"
    ) {
      defaultTheme.overrides.MuiPaper.elevation23.backgroundColor = getColour(
        brandingOverRide.navigationBackgroundColour,
      );
    }
    let navigationType = "";
    if (brandingOverRide.navigationType) {
      navigationType = brandingOverRide.navigationType;
    }

    this.setState({
      fieldErrors,
      actionErrors,
      gitVersion,
      javascriptCacheDate,
      loginEndpoint,
      brandingOverRide,
      theme: createTheme(defaultTheme),
      imageUrl,
      imageFilename,
      showLogo,
      footerText,
      navigationType,
    });

    // Media breaking
    const handler = (e) => this.setState({ matches: e.matches });
    window.matchMedia("(min-width: 960px)").addEventListener("change", handler);
  };

  getPageNavigation = () => {
    return window.top.numberManagerNavigation;
  };

  render = () => {
    const links = this.getPageNavigation();
    let Component = DefaultLayout;

    let imagePath = `${this.state.imageUrl}${this.state.imageFilename}`;
    if (this.state.navigationType) {
      Component =
        this.state.navigationType === "vertical" ? Vertical : Horizontal;
      if (
        !this.state.imageFilename ||
        this.state.imageFilename === "transparent.gif"
      ) {
        imagePath = "/_client/images/custom/number-manager-icon.png";
      }
    }
    return (
      <MuiThemeProvider theme={this.state.theme}>
        <Component links={links} imagePath={imagePath} />
      </MuiThemeProvider>
    );
  };
}

Navigation.propTypes = { jwt: PropTypes.string };
